import { Editor, Range } from '..';

export const isSelectionCollapsed = (editor: Editor) => {
    if (!editor.selection) {
        return false;
    }

    return Range.isCollapsed(editor.selection);
};
